import gele from './gele.js';

/**
 * Gtlt.
 *
 * @param {number} m
 * @param {number} n
 * @param {Iterable} iterable
 */
const gtlt = (m, n, iterable) => gele(m + 1, n - 1, iterable);
export default gtlt;
